import type { Template } from '@/modules/templates/types/templates.types';
import { DocxBuilderProvider } from './docx-builder/context';
import { DocxBuilderLayout } from './docx-builder/layout';

interface DocxTemplateBuilderProps {
  template: Template;
  orgSlug: string;
  orgId: string;
}

export default function DocxTemplateBuilder({ template, orgSlug, orgId }: DocxTemplateBuilderProps) {
  return (
    <DocxBuilderProvider template={template} orgSlug={orgSlug} orgId={orgId}>
      {/* 65px = h-16 header (64px) + 1px border */}
      <div className="h-[calc(100dvh-65px)] flex flex-col overflow-hidden">
        <DocxBuilderLayout />
      </div>
    </DocxBuilderProvider>
  );
}
